/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Plum_Whale_NodInputs */

const en_safe_plum_whale_nod = /** @type {(inputs: Safe_Plum_Whale_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

const de_safe_plum_whale_nod = /** @type {(inputs: Safe_Plum_Whale_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle`)
};

/**
* | output |
* | --- |
* | "Role" |
*
* @param {Safe_Plum_Whale_NodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const safe_plum_whale_nod = /** @type {((inputs?: Safe_Plum_Whale_NodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Plum_Whale_NodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_safe_plum_whale_nod(inputs)
	return de_safe_plum_whale_nod(inputs)
});